import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaEntrega } from "../model";
import { ListGuiasEntregaMem } from "./listmem";
import * as logic from "../logic"; 

export interface Props {
     state: models.ViajeAppIniciado;
     value: models.EntregaRealizadaViajeAppModel;
     onChange: (x: models.EntregaRealizadaViajeAppModel) => void;
}

/**Listado de las guias de entrega */
export  class ListGuiasEntregaNoRx extends React.PureComponent<Props> {
    state = (props: Props) => props.state;
    value = (props: Props) => props.value;
    claveUnica = createSelectorRx(this.value, value => value.ClaveUnica);

    items = createSelectorRx(this.state, this.claveUnica, (state, clave) => logic.obtenerGuiasDeState(state, clave));

    onSeleccionar = (entity: GuiaEntrega, value: boolean | null ) => {
        const nextValue = logic.onSeleccionarGuiaEntregaChange(this.props.value, entity.guia.IdRegistro, value);
        this.props.onChange(nextValue);
    }
    onMotivoChange = (entity : GuiaEntrega, value: string) => {
        const nextValue = logic.onMotivoGuiaEntregaChange(this.props.value, entity.guia.IdRegistro, value);
        this.props.onChange(nextValue);
    }
    
    render() {
        const items = this.items(this.props);
        return <ListGuiasEntregaMem items={items} onSeleccionar={this.onSeleccionar} onMotivoChange={this.onMotivoChange} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entrega/list/list.tsx